import { Widget } from 'jamespot-front-business';
import { WidgetDefinitionProps, WidgetsName } from 'jamespot-user-api';

export function getBuilderWidgets(namespace: string): WidgetDefinitionProps[] {
    switch (namespace) {
        case 'widget-article-image':
            return [Widget.definition(WidgetsName.ArticleTitle), Widget.definition(WidgetsName.ArticleButton)];
        case 'comment':
            return [
                Widget.definition(WidgetsName.CheckList),
                Widget.definition(WidgetsName.Presence),
                Widget.definition(WidgetsName.QuickSurvey),
            ];
        default:
            return [
                Widget.definition(WidgetsName.ArticleTitle),
                Widget.definition(WidgetsName.ArticleText),
                Widget.definition(WidgetsName.ArticleImage),
                Widget.definition(WidgetsName.ArticleButton),
                Widget.definition(WidgetsName.ArticleSlider),
                Widget.definition(WidgetsName.ArticleAttachment),
                Widget.definition(WidgetsName.Presence),
            ];
    }
}
